import { render } from "./Peintures.vue?vue&type=template&id=0cdd5b03"
import script from "./Peintures.vue?vue&type=script&lang=js"
export * from "./Peintures.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__